export default "<p>asset-tree works!</p>\r\n";